/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {BatchGetEmploymentRequest} from '@cash-web/protos/squareup/roster/mds.pb'
import {BatchGetEmploymentResponse} from '@cash-web/protos/squareup/roster/mds.pb'


export const batchGetEmployment = (request: BatchGetEmploymentRequest, options?: CashRequestOptions) => post<BatchGetEmploymentRequest, BatchGetEmploymentResponse>("/2.0/cash/batch-get-employment", request, {...options, rejectOnError: true })